import ReactMounter from 'lib/ReactMounter';
import SmartSalesPage from 'pages/SmartSalesPage/SmartSalesPage';

ReactMounter.registerComponentToMountOnLoad('SmartSalesPage', SmartSalesPage);
